import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { company, navLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <div className="h-10 w-10 rounded-lg bg-cyan-500 text-slate-900 grid place-items-center font-bold">
              411
            </div>
            <div>
              <div className="font-bold text-white">{company.name}</div>
              <div className="text-xs text-slate-400">{company.tagline}</div>
            </div>
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-md">
            Your friendly neighborhood IT &amp; Tech Savvy guy. AI-powered websites, SEO, lead generation and
            digital marketing. USMC veteran-owned, serving the entire USA.
          </p>
          <div className="mt-5 space-y-2 text-sm">
            <a href={`tel:${company.phone}`} className="flex items-center gap-2 hover:text-cyan-400">
              <Phone className="h-4 w-4 text-cyan-400" /> {company.phone}
            </a>
            <a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-cyan-400">
              <Mail className="h-4 w-4 text-cyan-400" /> {company.email}
            </a>
            <div className="flex items-center gap-2">
              <MapPin className="h-4 w-4 text-cyan-400" /> {company.location}
            </div>
          </div>
        </div>

        <div>
          <div className="text-white font-bold mb-4">Quick Links</div>
          <ul className="space-y-2 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="hover:text-cyan-400">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-white font-bold mb-4">Services</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#services" className="hover:text-cyan-400">AI Website Design</a></li>
            <li><a href="#services" className="hover:text-cyan-400">SEO &amp; AEO</a></li>
            <li><a href="#services" className="hover:text-cyan-400">Lead Generation</a></li>
            <li><a href="#services" className="hover:text-cyan-400">Google Business</a></li>
            <li><a href="#services" className="hover:text-cyan-400">IT Remote Support</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row gap-2 items-center justify-between text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {company.name}. All rights reserved.</div>
          <div>{company.site} · Proudly USMC Veteran Owned</div>
        </div>
      </div>
    </footer>
  );
}
